import ArrowRight from '@mui/icons-material/ArrowRight'
import {IconButton} from '@mui/material'
import type {IconButtonProps} from '@mui/material/IconButton/IconButton'
import {styled} from '@mui/material/styles'
import {type ElementType, memo} from 'react'

const StyledIconButton = memo(styled(IconButton)(({theme}) => ({
  '& svg': {
    transition: theme.transitions.create('transform'),
    transform: 'translateX(0) rotate(0)',
  },
  '&:hover': {
    backgroundColor: 'unset',
    '& svg:first-of-type': {
      transform: 'translateX(-4px) rotate(-20deg)',
    },
    '& svg:last-of-type': {
      right: 0,
      opacity: 1,
    },
  },
})))

export const AnimatedIconButton = memo(<C extends ElementType>(
  props: IconButtonProps<C, {
    component?: C
  }>) => {
  const {children, ...rest} = props

  return <StyledIconButton {...rest}>
    {children}
    <ArrowRight sx={{position: 'absolute', right: 4, opacity: 0}}/>
  </StyledIconButton>
},
)
